class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerDetails = this.header.querySelectorAll('header-menu > details');
    this.menuItems = this.header.querySelectorAll('.header__menu-item');
    this.toggleType = this.dataset.toggle;

    if (this.toggleType == 'hover') {
      this.mainDetailsToggle.addEventListener('mouseover', this.onMouseHover.bind(this));
      document.addEventListener('mouseover', this.onDocumentMouseHover.bind(this));
      this.menuItems.forEach((element) => {
        element.addEventListener('mouseover', this.onMenuItemMouseHover.bind(this));
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseHover() {
    this.closeAllHeaderDetails();
    this.mainDetailsToggle.open = true;    
  }

  onDocumentMouseHover(event) {
    const target = event.target;
    
    if (target.closest('.header-wrapper') === null) {
      this.mainDetailsToggle.open = false;
    }
  }

  onMenuItemMouseHover() {
    this.closeAllHeaderDetails();
  }

  closeAllHeaderDetails() {
    this.headerDetails.forEach((element) => {
      element.open = false;
    }); 
  }
}

customElements.define('header-menu', HeaderMenu);
